module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/socials/facebook-1114d96a4147c76e4c4a9194bbe4712c.svg";